import type { SchemaInput } from '../shared/schema-input.js';

export type ServiceAreaFlowExperimentVariant = 'control' | 'skip_adjust';

export function isServiceAreaFlowExperimentVariant(
  value: SchemaInput,
): value is ServiceAreaFlowExperimentVariant {
  return value === 'control' || value === 'skip_adjust';
}
